<template>
  <apexchart type="donut" :options="chartOptions" :series="series" class="graph" />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'

export default {
  name: 'DonutChart',
  props: ['valores'],
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    chartOptions: {
      labels: ['Disponível', 'Em Pausa', 'Em Ligação'],
      colors: ['#66BB6A', '#EF5350', '#FDD835'],
      legend: {
        show: false,
      },
      chart: {
        type: 'donut',
      },
      fill: {
        type: 'gradient',
      },
      tooltip: {
        y: {
          formatter: function(value) {
            if (value >= 60) {
              var minutes = Math.floor(value / 60)
              const secs = String(value % 60).padStart(2, '0')
              const hours = String(Math.floor(minutes / 60)).padStart(2, '0')
              minutes = String(minutes % 60).padStart(2, '0')

              return `${hours}:${minutes}:${secs}`
            } else {
              return moment(value, 'ss').format('HH:mm:ss')
            }
          },
        },
      },
      yaxis: {
        labels: {
          formatter: value => {
            if (value >= 60) {
              var minutes = Math.floor(value / 60)
              const secs = String(value % 60).padStart(2, '0')
              const hours = String(Math.floor(minutes / 60)).padStart(2, '0')
              minutes = String(minutes % 60).padStart(2, '0')

              return `${hours}:${minutes}:${secs}`
            } else {
              return moment(value, 'ss').format('HH:mm:ss')
            }
          },
        },
      },
    },
    series: [],
  }),

  watch: {
    valores: {
      deep: true,
      immediate: true,
      handler() {
        this.series.splice(0)
        this.series = [...this.valores]
        this.series.splice(0, 1, this.series[0])
      },
    },
  },
}
</script>
